<template>
  <div class="home">
    <header-view />
    <ContactDetail />
    <ContactForm
      v-model:name="name"
      v-model:email="email"
      v-model:phone="phone"
      v-model:message="message"
      :error="error"
      :success="success"
      :emailError="emailError"
      :onSubmit="onSubmit"
    />
    <AccordianView />
    <GetQoute />
    <footer-view />
  </div>
</template>
<script>
import HeaderView from "@/components/UiComponents/HeaderView.vue";
import AccordianView from "@/components/UiComponents/AccordianView.vue";
import FooterView from "@/components/UiComponents/FooterView.vue";
import { ref } from "vue";
import ContactDetail from "@/components/ContackUs/ContactDetail.vue";
import ContactForm from "@/components/ContackUs/ContactForm.vue";
import GetQoute from "@/components/UiComponents/GetQoute.vue";
export default {
  name: "ContactUs",
  components: {
    HeaderView,
    ContactDetail,
    ContactForm,
    AccordianView,
    GetQoute,
    FooterView,
  },
  setup() {
    const name = ref("");
    const phone = ref("");
    const email = ref("");
    const message = ref("");
    const error = ref(false);
    const success = ref(false);
    const emailError = ref(false);

    async function onSubmit() {
      if (!email.value.includes("@") || !email.value.includes(".")) {
        emailError.value = true;
        return;
      }
      const response = await fetch("https://merwylan.nl:4523/merwylan", {
        method: "POST",
        body: JSON.stringify({
          name: name.value,
          phone: phone.value,
          email: email.value,
          message: message.value,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .catch(() => (error.value = true));
      if (response.ok) {
        success.value = true;
      } else {
        error.value = true;
      }
    }
    return {
      onSubmit,
      name,
      phone,
      email,
      message,
      success,
      error,
      emailError,
    };
  },
};
</script>
